<!-- 测试页面 -->
<template>
    <div class="container containerBox tcs-box">
       <machine-set></machine-set>
       <!-- <admin-home></admin-home> -->
    </div>
</template>

<script>
import MachineSet from '@/views/MachineMana/MachineSet.vue'
// import AdminHome from '@/views/BaseConfigMana/AdminHome/AdminHome'

import { mapGetters } from "vuex"; 
export default {
    name:"testpage",
    data () {
        return {
        };
    },
    computed: {
        
    },
    mounted() {
       
    },
    components: {
        MachineSet
        // AdminHome,
    },
    methods: {
        
    }
}

</script>
<style lang='less'>
.tcs-box{
    height: calc(100% - 60px);
    padding: 0;
}
</style>